// 权限角色接口

import request from '@/utils/request'
import qs from 'qs'

// 新增用户组
export function addGroup(data: { name: string }) {
  return request({
    url: '/author/addGroup',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改用户组
export function updateGroup(data: { id: string | number, name: string }) {
  return request({
    url: '/author/editGroup',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除用户组
export function deleteGroup(data: { id: string | number }) {
  return request({
    url: '/author/delGroup',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 添加用户组路由权限: 接口权限
export function addGroupRouter(data: { id: string | number, routerId: string }) {
  return request({
    url: '/author/groupAddRouter',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除用户组路由权限: 接口权限
export function deleteGroupRouter(data: { id: string | number, routerId: string }) {
  return request({
    url: '/author/groupDeleteRouter',
    method: 'post',
    data: qs.stringify(data)
  })
}
